/**
 * Die Kennung dieser geöffneten Seite. (29.09.2026, Ticket 2796)
 *
 * Einmal je Laden erzeugt, nirgends gespeichert. Die Sprechtaste schickt sie
 * mit; kommt das Echo über den Kanal zurück, erkennt die Seite ihr eigenes
 * und zeichnet es nicht doppelt. Warum: shared/geraet-kennung.ts.
 */

function neueKennung(): string {
  const bytes = new Uint8Array(8);
  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

export const EIGENES_GERAET = neueKennung();
